import GenericList, { GenericListItem } from '../../../components/GenericList';
import Popover from '../../../components/Popover';
import IconButton from '../../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type AlertData = { alertDescription: string };

export type PopoverWithAlertsProps = React.PropsWithChildren<{
  alertsData: AlertData[];
}>;

const PopoverWithAlerts = ({ alertsData }: PopoverWithAlertsProps) => {
  const popOverWithLinksBody = (
    <Container className={'px-0'}>
      <GenericList>
        {alertsData.map((alertData, index) => {
          return (
            <GenericListItem key={index} withoutBorder={false}>
              <Container className={'px-0 py-6 d-flex align-items-center'}>
                <div
                  className={
                    'p-0 d-flex justify-content-center align-items-center alert mb-0'
                  }
                >
                  <FontAwesomeIcon
                    className={'alert-icon'}
                    icon={light('exclamation-circle')}
                  />
                </div>
                <span className={'ms-5 text-fs-6 fw-light alert-description'}>
                  {alertData.alertDescription}
                </span>
              </Container>
            </GenericListItem>
          );
        })}
      </GenericList>
    </Container>
  );

  return (
    <Popover
      bsPrefix={'popover with-alerts'}
      trigger="click"
      placement={'bottom-start'}
      popoverBody={popOverWithLinksBody}
    >
      <Container className={'px-0 d-flex align-items-center'}>
        <IconButton variant={'icon-alert'} icon={light('exclamation-circle')} />
        <span
          className={'ms-4 text-fs-6 fw-light text-dark-grey'}
        >{`${alertsData.length} Alerts`}</span>
      </Container>
    </Popover>
  );
};

export default PopoverWithAlerts;
